<template>
  <div class='risk-score-percentage' :style="cssVars" :class='{ "short-form": shortForm }'>
    <div class="result" :style="cssVars" :class='{ "short-form": shortForm }'>{{ text }}</div>
    <div class='value_section' :style="cssVars" :class='{ "short-form": shortForm }'>
      <div class='value' :style="{'color': color}" :class='{ "short-form": shortForm }'>{{ score }} {{recalculateRequired ? "*": ""}}</div>
      <div class='label' v-if='!shortForm'>
        <span v-if='optimized'> {{ $t('risk.score.current.optimized') }} </span>
        <span v-else> {{ $t('risk.score.current.percentile')}} </span>
      </div>
    </div>
  </div>
</template>

<script>
import { hexToRgba } from '@/utils/colorUtils';

export default {
  name: 'RiskScorePercentage',
  props: {
    shortForm: {
      type: Boolean,
      required: false,
      default: false,
    },
    score: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    optimized: {
      type: Boolean,
      required: false,
      default: false,
    },
    recalculateRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    cssVars() {
      return {
        '--background': `${hexToRgba(this.color, 0.1)}`,
        '--color': this.color,
      };
    },
  },
};
</script>

<style lang='scss' scoped>
@import '~@/assets/styles/design-system';

.risk-score-percentage {
  display: flex;
  padding: rem(2) rem(5);
  width: fit-content;
  height: fit-content;
  .result{
    font-family: $font-family-black;
    font-size: rem(64);
    text-transform: uppercase;
    color: var(--color);
    &.short-form {
      font-size: $font-size-2xl;
    }
  }
    &__divider{
      margin-left: $space-4;
      max-height: rem(75);
    }
  .value_section {
    padding-left: $space-6;
    display: flex;
    flex-direction: column;
    margin-top: $space-2;
    .value{
      font-family: $font-family-medium;
      font-size: rem(36);
      &.short-form {
        font-size: $font-size-lg;
      }
    }
    .label{
      color: var(--text-secondary);
      font-family: $font-family-regular;
      font-size: $font-size-2xs;
      letter-spacing: rem(1.1);
      line-height: $space-4;
      text-transform: uppercase;
      max-width: rem(110);
      display: flex;
      flex-direction: column;
    }
    &.short-form {
      margin-top: $space-1;
      padding-left: $space-1-5;
    }
  }
  .recalculate {
    margin-left: rem(2);
    margin-top: $space-5;
    align-items: center;
    border-radius: $radius-md;
    display: flex;
    height: $space-4;
    justify-content: center;
    width: $space-4;
    color: var(--text-primary);
  }
  &.short-form {
    border-radius: $radius-sm;
    &:hover {
      background-color: var(--background);
    }
  }
}
</style>
